<template>
  <div>
    <header class="header b-blue">
      <div class="container" v-if="!downloading">
        <div class="row">
          <b-breadcrumb :items="items" class="bg-transparent ml-3 p-0"></b-breadcrumb>
          <div class="col-md-12 col-sm-12">
            <h3>Empleos para tu perfil</h3>
            <p>Tenemos empleos que se adaptan a tu perfil.</p>
          </div>
        </div>
      </div>
    </header>
    <section class="jobs-recomendation">
      <div class="container" v-if="downloading">
        <div class="container text-center py-5 font-gray-dark">
          <b-spinner v-if="downloading"  label="Espere ..."></b-spinner>
          <br>
          Espere un momento...
        </div>
      </div>
      <div class="container" v-if="!downloading">
        <div class="row my-5 " v-if="jobsRecomendation.length > 0">
<!--          <JobMini v-for="job in jobsRecomendation" :key="job.id" :id="job.id" :title="job.titulo" :location="job.ubicacion" :type="job.tipo_empleo" :url_public="job.url_public" :enterprise="job.enterprise_min" :link_enterprise="job.enterprise_min.url_public"/>-->
              <JobRecomendation v-for="empleo in jobsRecomendation" :key="empleo.id" :empleo="empleo"/>
        </div>
        <div class="row py-5" v-else>
          <div class="col-lg-12 text-center font-gray-dark">
            <h1 class="font-weight-bold">¡Ups!</h1>
            <h5>No se han encontrado empleos recomendados</h5>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style lang="">
.header{
  padding-top: 5em;
  padding-bottom: 5em;
}
@media only screen and (max-width: 600px) {
  .header{
    text-align: center;
  }
}
</style>
<script>
import JobMini from './components/home/JobMin'
import JobRecomendation from "./components/home/JobRecomendation";
export default {
  components:{
    'JobMini': JobMini,
    'JobRecomendation':JobRecomendation
  },
  data() {
    return {
      downloading: false,
      jobsRecomendation:{},
      items: [
        {
          text: "Empleos",
          href: "/empleos"
        },
        {
          text: "Recomendaciones",
          active: true
        }
      ],
    };
  },
  mounted() {
    this.recomendations()
  },
  methods: {
    recomendations(){

      this.downloading = true

      this.api.get('student/cv/profile/recomendations').then(({data}) => {

        if(data.data.jobs.length){
          this.jobsRecomendation = data.data.jobs
        }
          this.downloading = false
        // else{
        //   this.wantedJobs()
        // }

      }).catch(err => {
        this.downloading = false
      })

    },
    wantedJobs(){
      this.api.get(`wanted_jobs`)
          .then(({data}) => {

            if(data.data.length){

              this.jobsRecomendation = data.data

              this.downloading = false

            }

          }).catch(e => { this.downloading = false })
    }

  }


  // computed: {
  //   jobsRecomendation: function() {
  //     return this.$store.getters.jobsRecomendation;
  //   },
  // },
};
</script>



// WEBPACK FOOTER //
// src/components/#public/job/JobsRecomendation.vue